import {contactSupport} from '../lib/mail.ts'

/** Opens a support mail on click of elements with `data-contact-support="<subject>"`, and from inline `onclick` handlers in posts */
export function initSupportButtons() {
    window.contactSupport = contactSupport
    document.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return
        const button = event.target.closest<HTMLElement>('[data-contact-support]')
        if (button) contactSupport(button.dataset.contactSupport)
    })
}
